// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Tabs_navigation__Yp1zz","navigation__tab":"Tabs_navigation__tab__PjqMx","navigation__tab__active":"Tabs_navigation__tab__active__5qD4E"};